module.exports = __webpack_public_path__ + "img/tf.59456f1c.svg";